module.exports = __webpack_public_path__ + "static/foodstandslide-03-min-ad7a7015c956c1c9cd041d87514eafb2.jpg";